import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoStaffIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 73H121",
			stroke: "url(#paint0_linear_9434_32932)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 91H121",
			stroke: "url(#paint1_linear_9434_32932)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105 37C105 39.7614 102.761 42 100 42C97.2386 42 95 39.7614 95 37C95 34.2386 97.2386 32 100 32C102.761 32 105 34.2386 105 37Z",
			fill: "url(#paint2_linear_9434_32932)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_9434_32932)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M100 26C108.84 26 116 33.16 116 42C116 50.84 108.84 58 100 58C91.16 58 84 50.84 84 42C84 33.16 91.16 26 100 26Z",
				fill: "url(#paint3_linear_9434_32932)"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M127.025 66.7715C133.658 73.124 133.658 83.432 127.025 89.7885L103.002 112.81C101.346 114.397 98.6538 114.397 96.9977 112.81L72.9749 89.7885C66.3417 83.432 66.3417 73.124 72.9749 66.7674C79.608 60.4109 90.3645 60.4109 96.9977 66.7674L99.9958 69.6445L103.002 66.7674C109.635 60.4109 120.392 60.4149 127.025 66.7715Z",
				fill: "url(#paint4_linear_9434_32932)"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M145.333 85.9998C145.333 93.3636 139.364 99.3332 132 99.3332C124.636 99.3332 118.667 93.3636 118.667 85.9998C118.667 78.636 124.636 72.6665 132 72.6665C139.364 72.6665 145.333 78.636 145.333 85.9998Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M132 78.3335C132.552 78.3335 133 78.7812 133 79.3335V87.3335C133 87.8858 132.552 88.3335 132 88.3335C131.448 88.3335 131 87.8858 131 87.3335V79.3335C131 78.7812 131.448 78.3335 132 78.3335ZM132 90.3335C132.552 90.3335 133 90.7812 133 91.3335V92.6668C133 93.2191 132.552 93.6668 132 93.6668C131.448 93.6668 131 93.2191 131 92.6668V91.3335C131 90.7812 131.448 90.3335 132 90.3335Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_9434_32932",
				x1: 97,
				y1: 73.5,
				x2: 121,
				y2: 73.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_9434_32932",
				x1: 97,
				y1: 91.5,
				x2: 121,
				y2: 91.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_9434_32932",
				x1: 100,
				y1: 32,
				x2: 100,
				y2: 42,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_9434_32932",
				x1: 100,
				y1: 26,
				x2: 100,
				y2: 58,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_9434_32932",
				x1: 100,
				y1: 62,
				x2: 100,
				y2: 114,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_9434_32932",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 96,
					height: 96,
					fill: "white",
					transform: "translate(52 22)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNoStaffIcon);
export { ForwardRef as ReactComponent };
